import { css } from 'linaria';
import { fontFamily } from '../typography/typography.styles';

export const dense = css``;

export const root = css`
    &.ag-theme-alpine {
        --ag-foreground-color: var(--r-table-foreground);
        --ag-background-color: var(--r-table-background);
        --ag-header-foreground-color: var(--r-table-foreground);
        --ag-header-background-color: var(--r-table-background);

        --ag-odd-row-background-color: var(--r-table-odd-row-color);

        --ag-font-size: 14px;
        --ag-font-family: ${fontFamily};

        --ag-cell-horizontal-padding: 16px;

        --ag-borders: none;
        --ag-borders-row: solid 1px;
        --ag-row-border-color: var(--r-table-row-border-color);
    }

    &.ag-theme-alpine .ag-row {
        font-size: var(--ag-font-size);
    }

    &.ag-theme-alpine .ag-header-row {
        border-bottom: solid 2px var(--r-table-foreground);
    }

    &.ag-theme-alpine .ag-root ::-webkit-scrollbar {
        width: 8px;
    }
    &.ag-theme-alpine .ag-root ::-webkit-scrollbar-button {
        height: 0;
    }
    &.ag-theme-alpine .ag-root ::-webkit-scrollbar-track-piece {
        background: var(--r-table-background);
        padding-left: 10px;
        width: 8px;
    }
    &.ag-theme-alpine .ag-root ::-webkit-scrollbar-thumb {
        background: var(--r-table-scrollbar-thumb-color);
        border-radius: 4px;
        width: 8px;
    }

    .ag-ltr .ag-sort-indicator-icon {
        padding-left: 8px;
        padding-right: 0;
    }

    .ag-right-aligned-header .ag-sort-indicator-icon {
        padding-left: 0;
        padding-right: 8px;
    }
`;

export const centredColumnHeader = css`
    .ag-header-cell-label {
        justify-content: center;
    }
`;
export const centredColumnCell = css`
    text-align: center;
`;
export const dropdownColumnCell = css`
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`;
